import React, { useState } from "react";
import "./App.css";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import axios from "axios";
import {
  Button,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
  Modal,
  UncontrolledTooltip,
} from "reactstrap";
import { useForm } from "react-hook-form";

// reactstrap components
// import {
// } from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

// sections for this page
import Images from "./index-sections/Images.js";
import BasicElements from "./index-sections/BasicElements.js";
import Navbars from "./index-sections/Navbars.js";
import Tabs from "./index-sections/Tabs.js";
import Pagination from "./index-sections/Pagination.js";
import Notifications from "./index-sections/Notifications.js";
import Typography from "./index-sections/Typography.js";
import Javascript from "./index-sections/Javascript.js";
import Carousel from "./index-sections/Carousel.js";
import NucleoIcons from "./index-sections/NucleoIcons.js";
import CompleteExamples from "./index-sections/CompleteExamples.js";
import SignUp from "./index-sections/SignUp.js";
import Examples from "./index-sections/Examples.js";
import Download from "./index-sections/Download.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

function Index() {
  const { register, errors, handleSubmit, watch } = useForm({
    mode: "onBlur",
  });
  let [headText, setHeadText] = useState("Error");
  let [bodyText, setBodyText] = useState("Error");
  let [loader, setloader] = useState(false);
  const [modalLive, setModalLive] = React.useState(false);
  const onSubmit = async (data) => {
    // alert(document.getElementById("message").value);
    document.getElementById("subBtn").disabled = true;
    setloader(true);
    try {
      require("dotenv").config();
      const config = {
        method: "post",
        url: process.env.REACT_APP_LOCAL,
        headers: { authorization: process.env.REACT_APP_AUTH },
        params: {
          name: document.getElementById("name").value,
          email: document.getElementById("email").value,
          message: document.getElementById("message").value,
        },
      };
      let result = await axios(config);
      if (result.data.message == "success") {
        setloader(false);
        // document.getElementById("subBtn").innerHTML = "Send Message";
        document.getElementById("subBtn").disabled = false;
        setHeadText("Success");
        setBodyText("Message sent successfully!");
        setModalLive(true);
        document.getElementById("name").value = "";
        document.getElementById("email").value = "";
        document.getElementById("message").value = "";
      } else {
        setloader(false);
        // document.getElementById("subBtn").innerHTML = "Send Message";
        document.getElementById("subBtn").disabled = false;
        setHeadText("Error");
        setBodyText("Internal Server Error");
        setModalLive(true);
      }
    } catch (err) {
      setloader(false);
      // document.getElementById("subBtn").innerHTML = "Send Message";
      document.getElementById("subBtn").disabled = false;
      setHeadText("Error");
      setBodyText("Internal Server Error");
      setModalLive(true);
      console.log(err);
    }
  };
  const [pills, setPills] = React.useState("1");
  const [firstFocus, setFirstFocus] = React.useState(false);
  const [lastFocus, setLastFocus] = React.useState(false);
  React.useEffect(() => {
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  React.useEffect(() => {
    document.body.classList.add("landing-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    return function cleanup() {
      document.body.classList.remove("landing-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <IndexHeader />
        <div className="main">
          <Modal toggle={() => setModalLive(false)} isOpen={modalLive}>
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLiveLabel">
                {headText}
              </h5>
              <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={() => setModalLive(false)}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <p>{bodyText}</p>
            </div>
            {/* <div className="modal-footer">
          <Button
            color="secondary"
            type="button"
            onClick={() => setModalLive(false)}
          >
            Close
          </Button>
        </div> */}
          </Modal>
          <Images />
          {/* <BasicElements />
          <Navbars />
          <Tabs />
          <Pagination />
          <Notifications />
          <Typography />
          <Javascript />
          <Carousel />
          <NucleoIcons />
          <CompleteExamples />
          <SignUp />
          <Examples />
          <Download /> */}
        </div>
        <div id="section-about-us" className="section section-about-us">
          <Container>
            <Row>
              <Col className="ml-auto mr-auto text-center" md="8">
                <h2 className="title">Who we are?</h2>
                <h5 className="description">
                  At ForKodes, we strive to provide the best quality softwares
                  and cloud based solutions. All our products are unique and
                  elegant.
                </h5>
                <h5 className="description">
                  Innovation is what keeps us ahead in the industry.
                  <br /> Our team is proficient with most of the latest
                  technologies and therefore we deliver products that are of top
                  quality.
                </h5>
              </Col>
            </Row>
            <div className="separator separator-primary"></div>
            <div className="section-story-overview">
              <Row>
                <Col md="6">
                  <div
                    className="image-container image-left"
                    style={{
                      backgroundImage:
                        "url(" + require("assets/img/saloon.png") + ")",
                    }}
                  >
                    <p className="blockquote blockquote-info">
                      "I do see the beauty in the rules, the invisible code of
                      chaos hiding behind the menacing face of order." <br></br>
                      <br></br>
                      <small>-Eliot Alderson</small>
                    </p>
                  </div>

                  <div
                    className="image-container"
                    style={{
                      backgroundImage:
                        "url(" + require("assets/img/mail.png") + ")",
                    }}
                  ></div>
                </Col>
                <Col md="5">
                  <div
                    className="image-container image-right"
                    style={{
                      backgroundImage:
                        "url(" + require("assets/img/sastabuy.png") + ")",
                    }}
                  ></div>
                  <h3>Our Softwares:</h3>
                  <p>
                    We are currently developing an application which will be
                    available to download soon on both Android and IOS
                    platforms. It is designed to ease the efforts of its users.
                    Stay tuned for more updates on this application.
                  </p>
                  <p>
                    Our E-commerce website,{" "}
                    <a target="_blank" href="https://sastabuy.in">
                      Sastabuy
                    </a>{" "}
                    provides customers with a plethora of unique products,
                    ranging from various electronics to handicrafts and many
                    more! All with an irresistible price tag.
                  </p>
                  <p>
                    <a target="_blank" href="https://mail.forkodes.com">
                      Forkodes Mail
                    </a>{" "}
                    is a platform to host emails for your domain. You can
                    provide your own sheet with customized usernames or we can
                    generate it for you, in bulk!! Be it 1000 or 10,000 emails,
                    we've got you covered. Please contact us to get a quote.
                  </p>
                  <p></p>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
        <div id="section-services" className="section section-team text-center">
          <Row>
            <Col className="ml-auto mr-auto" md="6">
              <h4 className="title text-center">Services</h4>
              <div className="nav-align-center">
                <Nav
                  className="nav-pills-info nav-pills-just-icons"
                  pills
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      className={pills === "1" ? "active" : ""}
                      href="#website-development"
                      id="website-development"
                      onClick={(e) => {
                        e.preventDefault();
                        setPills("1");
                      }}
                    >
                      <i className="now-ui-icons tech_tv"></i>
                      <UncontrolledTooltip target="#website-development">
                        Website Development
                      </UncontrolledTooltip>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={pills === "2" ? "active" : ""}
                      href="#mobile-development"
                      id="mobile-development"
                      onClick={(e) => {
                        e.preventDefault();
                        setPills("2");
                      }}
                    >
                      <i className="now-ui-icons tech_mobile"></i>
                      <UncontrolledTooltip target="#mobile-development">
                        Mobile App Development
                      </UncontrolledTooltip>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={pills === "3" ? "active" : ""}
                      href="#software-development"
                      id="software-development"
                      onClick={(e) => {
                        e.preventDefault();
                        setPills("3");
                      }}
                    >
                      <i className="now-ui-icons design_app"></i>
                      <UncontrolledTooltip target="#software-development">
                        Software Development
                      </UncontrolledTooltip>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Col>
            <TabContent className="gallery" activeTab={"pills" + pills}>
              <TabPane tabId="pills1">
                <Col className="ml-auto mr-auto" md="10">
                  <Row className="collections">
                    <Col md="6">
                      <h5 className="description">
                        Developing websites with a spectrum defined by the
                        client.
                        <br /> All the websites are user friendly, responsive
                        and elegant. We also provide maintenance services for
                        all sorts of websites.
                      </h5>
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/web-app.jpg")}
                      ></img>
                    </Col>
                    <Col md="6">
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/web-app2.jpg")}
                      ></img>
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/sastabuy.png")}
                      ></img>
                    </Col>
                  </Row>
                </Col>
              </TabPane>
              <TabPane tabId="pills2">
                <Col className="ml-auto mr-auto" md="10">
                  <Row className="collections">
                    <Col md="6">
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/mob-app2.jpg")}
                      ></img>

                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/mob-app4.jpg")}
                      ></img>
                    </Col>
                    <Col md="6">
                      <h5 className="description">
                        We develop mobile applications for both Android and IOS
                        platforms.
                        <br /> Our team is proficient with most of the latest
                        technologies and therefore we deliver products that are
                        of top quality.
                      </h5>
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/mob-app3.jpg")}
                      ></img>
                    </Col>
                  </Row>
                </Col>
              </TabPane>
              <TabPane tabId="pills3">
                <Col className="ml-auto mr-auto" md="10">
                  <Row className="collections">
                    <Col md="6">
                      <h5 className="description">
                        Want a custom software for your buisness or personal
                        needs?
                        <br /> We've got you covered! With a local software that
                        will run on your device, or a software that has central
                        control over your business.
                      </h5>
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/cust-app.jpg")}
                      ></img>
                      {/* <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/bg8.jpg")}
                      ></img> */}
                    </Col>
                    <Col md="6">
                      <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/web-app3.jpg")}
                      ></img>
                      {/* <img
                        alt="..."
                        className="img-raised"
                        src={require("assets/img/bg6.jpg")}
                      ></img> */}
                    </Col>
                  </Row>
                </Col>
              </TabPane>
            </TabContent>
          </Row>
        </div>
        <div id="section-team" className="section section-team text-center">
          <Container>
            <h2 className="title">Here is our team</h2>
            <div className="team">
              <Row>
                <Col md="6">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/savio_white.jpg")}
                    ></img>
                    <h4 className="title">Savio Soloman</h4>
                    <p className="category text-info">CEO</p>
                    <p className="description">
                      "Money isn't everything, Money is the only thing!"
                      <br />- Floyd Mayweather
                    </p>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      target="_blank"
                      href="https://twitter.com/saviosoloman"
                      // onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-twitter"></i>
                    </Button>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      target="_blank"
                      href="https://www.instagram.com/saviyoo/"
                      // onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-instagram"></i>
                    </Button>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      target="_blank"
                      href="https://www.facebook.com/savio.soloman.1"
                      // onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-facebook-square"></i>
                    </Button>
                  </div>
                </Col>
                <Col md="6">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/uttam2zoom.jpg")}
                    ></img>
                    <h4 className="title">Uttam Pandey</h4>
                    <p className="category text-info">CTO</p>
                    <p className="description">
                      There's no force that will stop you from achieving what
                      you desire.
                    </p>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      target="_blank"
                      href="https://twitter.com/Uttam39052848"
                      // onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-twitter"></i>
                    </Button>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      target="_blank"
                      href="https://www.instagram.com/uttam_12/"
                      // onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-instagram"></i>
                    </Button>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      target="_blank"
                      href="https://www.facebook.com/uttam.pandey.142"
                      // onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-facebook-square"></i>
                    </Button>
                  </div>
                </Col>
                {/* <Col md="4">
                  <div className="team-player">
                    <img
                      alt="..."
                      className="rounded-circle img-fluid img-raised"
                      src={require("assets/img/eva.jpg")}
                    ></img>
                    <h4 className="title">Eva Jenner</h4>
                    <p className="category text-info">Fashion</p>
                    <p className="description">
                      You can write here details about one of your team members.
                      You can give more details about what they do. Feel free to
                      add some{" "}
                      <a href="#pablo" onClick={(e) => e.preventDefault()}>
                        links
                      </a>{" "}
                      for people to be able to follow them outside the site.
                    </p>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-google-plus"></i>
                    </Button>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-youtube"></i>
                    </Button>
                    <Button
                      className="btn-icon btn-round"
                      color="info"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fab fa-twitter"></i>
                    </Button>
                  </div>
                </Col> */}
              </Row>
            </div>
          </Container>
        </div>
        <div
          id="section-contact-us"
          className="section section-contact-us text-center"
        >
          <Container>
            <h2 className="title">Send us a message!</h2>
            <p className="description">Your project is very important to us.</p>
            <Row>
              <Col className="text-center ml-auto mr-auto" lg="6" md="8">
                <form id="form1" onSubmit={handleSubmit(onSubmit)}>
                  <InputGroup
                    name="name1"
                    className={
                      "input-lg" + (firstFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend" name="name2">
                      <InputGroupText name="name3">
                        <i className="now-ui-icons users_circle-08"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="First Name..."
                      name="name"
                      id="name"
                      type="text"
                      onFocus={() => setFirstFocus(true)}
                      onBlur={() => setFirstFocus(false)}
                      required
                      // ref={register({
                      //   required: true,
                      // })}
                    ></Input>
                  </InputGroup>
                  <InputGroup
                    name="email1"
                    className={
                      "input-lg" + (lastFocus ? " input-group-focus" : "")
                    }
                  >
                    <InputGroupAddon addonType="prepend" name="email2">
                      <InputGroupText name="email">
                        <i className="now-ui-icons ui-1_email-85"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Email..."
                      name="email"
                      id="email"
                      type="email"
                      onFocus={() => setLastFocus(true)}
                      onBlur={() => setLastFocus(false)}
                      required
                      // ref={register({
                      //   required: true,
                      // })}
                    ></Input>
                  </InputGroup>
                  <div className="textarea-container">
                    <Input
                      cols="80"
                      name="message"
                      id="message"
                      placeholder="Type a message..."
                      rows="4"
                      type="textarea"
                      required
                      // ref={register({
                      //   required: true,
                      // })}
                    ></Input>
                  </div>
                  <div className="send-button">
                    <Button
                      id="subBtn"
                      block
                      className="btn-round"
                      color="info"
                      type="submit"
                      // form="form1"
                      size="lg"
                    >
                      Send Message
                      {loader ? (
                        <Loader
                          type="Rings"
                          color="#ffff"
                          height={30}
                          width={30}
                        />
                      ) : (
                        ""
                      )}
                    </Button>
                  </div>
                </form>
              </Col>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default Index;
